module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('breadcrumb', {
    attrs: {
      "crumbs": _vm.crumbs
    }
  }), _vm._v(" "), _c('flash-message'), _vm._v(" "), _c('div', [(Object.keys(_vm.contract).length > 0) ? _c('div', {
    staticClass: "col-lg-12 ls-no-padding ls-display-flex align-items-stretch flex-wrap-wrap"
  }, [_c('div', {
    staticClass: "col-xlg-4 col-lg-5 ls-display-flex"
  }, [_c('div', {
    staticClass: "ls-box ls-sm-space ls-lg-margin-bottom ls-display-flex flex-wrap-wrap align-content-between"
  }, [_c('h4', {
    staticClass: "ls-title-4"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.contract_information')))]), _vm._v(" "), _c('div', {
    staticClass: "ls-clearfix ls-md-margin-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "row ls-display-flex flex-wrap-wrap"
  }, [_c('label', {
    staticClass: "ls-label col-xs-6 col-xlg-6 col-lg-6 ls-no-margin"
  }, [_c('b', {
    staticClass: "ls-label-text ls-text-md"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.identifier')))]), _vm._v(" "), _c('p', {
    staticClass: "ls-text-md"
  }, [_vm._v(_vm._s(_vm.contract.id))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xs-6 col-xlg-6 col-lg-6 ls-no-margin"
  }, [_c('b', {
    staticClass: "ls-label-text ls-text-md"
  }, [_vm._v(_vm._s(_vm.$t('contracts.attributes.code')))]), _vm._v(" "), _c('p', {
    staticClass: "ls-text-md"
  }, [_vm._v(_vm._s(_vm.contract.code))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xs-6 col-xlg-6 col-lg-6 ls-no-margin"
  }, [_c('b', {
    staticClass: "ls-label-text ls-text-md"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.status')))]), _vm._v(" "), _c('p', {
    staticClass: "ls-text-md status",
    class: _vm.contract.status
  }, [_vm._v(_vm._s(_vm.$t('contracts.attributes.statuses.' + _vm.contract.status)))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-lg-6 ls-no-margin"
  }, [_c('b', {
    staticClass: "ls-label-text ls-text-md"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.due_date')))]), _vm._v(" "), _c('p', {
    staticClass: "ls-text-md"
  }, [_vm._v(_vm._s(_vm.contract.day_expiration))])]), _vm._v(" "), (_vm.getCpf()) ? _c('label', {
    staticClass: "ls-label col-xs-6 col-xlg-6 col-lg-8 ls-no-margin"
  }, [_c('b', {
    staticClass: "ls-label-text ls-text-md"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.contract')))]), _vm._v(" "), _c('p', {
    staticClass: "ls-text-md"
  }, [_vm._v(_vm._s(_vm.subscriptionDate()))])]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xs-6 col-xlg-6 col-lg-8 ls-no-margin"
  }, [_c('b', {
    staticClass: "ls-label-text ls-text-md"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.charge_type')))]), _vm._v(" "), _c('p', {
    staticClass: "ls-text-md"
  }, [_vm._v(_vm._s(_vm.$t('contracts.attributes.charge_types.' + _vm.chargeType())))])])]), _vm._v(" "), _c('h4', {
    staticClass: "ls-title-4 ls-md-margin-top"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.client')))]), _vm._v(" "), _c('div', {
    staticClass: "ls-clearfix ls-md-margin-bottom"
  }), _vm._v(" "), _c('div', {
    staticClass: "row ls-display-flex flex-wrap-wrap"
  }, [_c('label', {
    staticClass: "ls-label col-lg-6 col-xs-6 col-xlg-6 ls-no-margin"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.client_type')))]), _vm._v(" "), (_vm.contract.customer.kind === 'P') ? _c('p', {
    attrs: {
      "data-test": "contract.customer.type"
    }
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.person')))]) : _c('p', [_vm._v(_vm._s(_vm.$t('contracts.show.person_customer')))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xs-6 col-lg-6 col-xlg-6 ls-no-margin"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.full_name')))]), _vm._v(" "), _c('p', {
    attrs: {
      "data-test": "contract.customer.name"
    }
  }, [_vm._v(_vm._s(_vm.contract.customer.name))])]), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xs-6 col-lg-6 col-xlg-6 ls-no-margin"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.mail')))]), _vm._v(" "), _c('p', {
    attrs: {
      "data-test": "contract.customer.email"
    }
  }, [_vm._v(_vm._s(_vm.contract.customer.email))])]), _vm._v(" "), (_vm.getCpf()) ? _c('label', {
    staticClass: "ls-label col-xs-6 col-lg-6 col-xlg-6 ls-no-margin"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.cpf')))]), _vm._v(" "), _c('p', {
    attrs: {
      "data-test": "contract.customer.cpf"
    }
  }, [_vm._v(_vm._s(_vm.getCpf()))])]) : _vm._e(), _vm._v(" "), (_vm.getCode()) ? _c('label', {
    staticClass: "ls-label col-lg-8 ls-no-margin"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.customer_code')))]), _vm._v(" "), _c('p', {
    attrs: {
      "data-test": "contract.customer.code"
    }
  }, [_vm._v(_vm._s(_vm.getCode()))])]) : _vm._e(), _vm._v(" "), (_vm.contract.customer.kind === 'C') ? _c('label', {
    staticClass: "ls-label col-xs-6 col-lg-6 col-xlg-6 ls-no-margin"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.cnpj')))]), _vm._v(" "), _c('p', {
    attrs: {
      "data-test": "contract.customer.cnpj"
    }
  }, [_vm._v(_vm._s(_vm.getCnpj()))])]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "ls-label col-xs-6 col-lg-6 col-xlg-6 ls-no-margin"
  }, [_c('b', {
    staticClass: "ls-label-text"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.phone')))]), _vm._v(" "), _c('p', {
    attrs: {
      "data-test": "contract.customer.phone"
    }
  }, [_vm._v(_vm._s(_vm.getPhone()))])]), _vm._v(" "), _c('div', {
    staticClass: "ls-float-right col-xs-6 col-lg-6 col-xlg-6  ls-display-flex align-itens-end"
  }, [_c('p', [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        name: 'edit_customer',
        params: {
          id: _vm.contract.customer.id
        }
      },
      "title": _vm.$t('contracts.show.view_client_detail')
    }
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.view_client_detail'))), _c('span', {
    staticClass: "ls-ico-shaft-right ls-xs-margin-left"
  })])], 1)])]), _vm._v(" "), (_vm.contract.recurring_payment_with_card) ? _c('div', {
    staticClass: "ls-md-margin-top"
  }, [_c('h4', {
    staticClass: "ls-title-4 ls-md-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.automatic_debit')))]), _vm._v(" "), _c('div', {
    staticClass: "row ls-display-flex flex-wrap justify-content-center"
  }, [_c('div', {
    staticClass: "col-md-4 col-lg-3 col-xlg-2 col-xs-4"
  }, [_c('img', {
    staticClass: "ls-no-padding",
    attrs: {
      "src": require('../../../assets/img/' + _vm.contract.card.payment_method + '-logo.png')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xlg-6"
  }, [_c('b', {
    staticClass: "ls-label-text font-size-14"
  }, [_vm._v(_vm._s(_vm.contract.card.name))]), _vm._v(" "), _c('p', {
    staticClass: "font-size-14"
  }, [_vm._v(_vm._s(_vm.contract.card.masked_pan))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('contracts.labels.card_expiration')) + ": " + _vm._s(_vm.contract.card.month) + "/" + _vm._s(_vm.contract.card.year))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-md-6 col-lg-12 col-xlg-4 ls-display-flex justify-content-end"
  }, [_c('authorized-link', {
    attrs: {
      "tag": "inactivate_debit_contract"
    }
  }, [_c('button', {
    staticClass: "ls-btn-primary no-margin ls-no-margin-bottom",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setInactivateAutomaticDebit($event)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('contracts.buttons.cancel_debit ')))])])])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.contract.recurring_payment_with_balance) ? _c('div', {
    staticClass: "ls-md-margin-top"
  }, [_c('h4', {
    staticClass: "ls-title-4 ls-md-margin-bottom"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.automatic_debit_with_yapay')))]), _vm._v(" "), _c('div', {
    staticClass: "ls-display-flex flex-wrap"
  }, [_c('div', {
    staticClass: "col-md-3 col-lg-3 col-xlg-2 col-xs-3"
  }, [_c('img', {
    staticClass: "ls-no-padding",
    attrs: {
      "src": require('../../../assets/img/logo-yp.svg')
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9 col-lg-9 col-xlg-6 ls-display-flex align-items-center ls-no-padding-left"
  }, [_c('b', {
    staticClass: "font-size-14 font-size-18"
  }, [_vm._v(_vm._s(_vm.contract.yapay_account.email_yapay))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-xs-12 col-md-6 col-xlg-4 ls-display-flex justify-content-end"
  }, [_c('authorized-link', {
    attrs: {
      "tag": "inactivate_debit_contract"
    }
  }, [_c('button', {
    staticClass: "ls-btn-primary ls-no-margin",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.setInactivateAutomaticDebit($event)
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('contracts.buttons.cancel_debit ')))])])])], 1)])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-7 col-xlg-8 ls-display-flex align-items-stretch flex-wrap-wrap"
  }, [_c('div', {
    staticClass: "ls-box ls-sm-space scroll-y max-height"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ls-float-left"
  }, [_c('h4', {
    staticClass: "ls-title-4"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.plans')))])]), _vm._v(" "), _c('authorized-link', {
    attrs: {
      "tag": "update_contract"
    }
  }, [(_vm.validStatus()) ? _c('div', {
    staticClass: "ls-float-right ls-md-margin-left"
  }, [_c('router-link', {
    staticClass: "ls-btn-primary ls-no-margin",
    attrs: {
      "to": {
        name: 'contracts_edit',
        params: {
          id: _vm.contract.id
        }
      }
    },
    slot: "button"
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', {
    staticClass: "ls-xs-margin-left"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.edit_subscription')))])])], 1) : _vm._e()]), _vm._v(" "), _c('modal-log', {
    attrs: {
      "id": _vm.contract.id
    }
  })], 1), _vm._v(" "), (_vm.contract.contract_plans.length) ? _c('table', {
    staticClass: "ls-table ls-sm-space ls-float-left ls-txt-center fixed_header"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('contracts.show.description')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contracts.show.value')))]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.discount')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contracts.show.charges_made')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contracts.show.discounts_launched')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contracts.show.status')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.orderedContractPlans), function(contract_plan, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(contract_plan.plan.name))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm.money.parseViewValue(contract_plan.price)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("R$ " + _vm._s(_vm.money.parseViewValue(_vm.discount(contract_plan))))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.chargesMade(contract_plan)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.discountsLaunched(contract_plan)))]), _vm._v(" "), _c('td', {
      class: contract_plan.status === 'active' ? 'active-contract-plan' : 'inactive-contract-plan'
    }, [_c('span', {
      staticClass: "ls-display-inline-block"
    }, [_vm._v(_vm._s(_vm.$t('contract_plans.attributes.statuses.' + contract_plan.status)))])])])
  }))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ls-box ls-sm-space ls-lg-margin-bottom min-width-100"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ls-float-left"
  }, [_c('h4', {
    staticClass: "ls-title-4"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.invoices')))])]), _vm._v(" "), _c('authorized-link', {
    staticClass: "ls-display-block-xs",
    attrs: {
      "tag": "index_entry"
    }
  }, [_c('div', {
    staticClass: "ls-float-right"
  }, [_c('button', {
    staticClass: "ls-btn-primary ls-no-margin",
    on: {
      "click": function($event) {
        _vm.setEntryData()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('contracts.show.add_entry')))])])])]), _vm._v(" "), (_vm.contract.status === 'active') ? _c('div', {
    staticClass: "ls-float-right ls-md-margin-left"
  }, [_c('button', {
    staticClass: "ls-btn-primary ls-xs-margin-rigth-in-md ls-no-margin ls-xs-margin-top-in-sm",
    on: {
      "click": function($event) {
        _vm.setSeparateInvoice()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('contracts.show.separate_invoice')))])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ls-clearfix ls-md-margin-bottom"
  }), _vm._v(" "), (_vm.invoices.length) ? _c('table', {
    staticClass: "ls-table ls-txt-center ls-xs-space fixed_header"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('contracts.show.emission_date')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contracts.show.value')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contracts.show.status')))]), _vm._v(" "), _c('th', {
    staticClass: "ls-display-none-xs"
  }, [_vm._v(_vm._s(_vm.$t('contracts.show.payment_date')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('contracts.show.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.invoices), function(invoice, index) {
    return (index + 1 <= _vm.limitNumber || _vm.showAllInvoices) ? _c('tr', {
      class: {
        'alert-line': _vm.contract.pending_payment
      }
    }, [_c('td', [_vm._v("\n                " + _vm._s(_vm.date.parseDate(invoice.created_at))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.$t('contracts.show.due_date')) + ": " + _vm._s(_vm.invoiceDueDate(invoice.due_date)))])]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm.money.parseViewValue(invoice.amount_due)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$t('invoices.attributes.statuses.' + invoice.status)))]), _vm._v(" "), _c('td', {
      staticClass: "ls-display-none-xs"
    }, [_vm._v(_vm._s(_vm.invoicePaymentDate(invoice)))]), _vm._v(" "), _c('td', {
      staticClass: "alignment-by-size"
    }, [_c('a', {
      staticClass: "ls-btn ls-no-margin ls-btn-default ls-cursor-pointer ls-float-right",
      on: {
        "click": function($event) {
          _vm.openInvoice(invoice.id)
        }
      },
      slot: "button"
    }, [_vm._v(_vm._s(_vm.$t('application.button.detail')))])])]) : _vm._e()
  }))]) : _c('p', {
    staticClass: "ls-txt-center"
  }, [_vm._v(_vm._s(_vm.$t('invoices.alerts.not_available')))]), _vm._v(" "), _c('div', {
    staticClass: "ls-txt-center"
  }, [(_vm.itemsCount > _vm.limitNumber) ? _c('button', {
    staticClass: "ls-btn ls-no-margin",
    on: {
      "click": _vm.toggleInvoices
    },
    slot: "button"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('contracts.show.show_more_invoices')))])]) : _vm._e()])])]), _vm._v(" "), _c('modal-inactivate-automatic-debit', {
    model: {
      value: (_vm.inactivateAutomaticDebit),
      callback: function($$v) {
        _vm.inactivateAutomaticDebit = $$v
      },
      expression: "inactivateAutomaticDebit"
    }
  }), _vm._v(" "), _c('modal-add-entry', {
    model: {
      value: (_vm.entryObjects),
      callback: function($$v) {
        _vm.entryObjects = $$v
      },
      expression: "entryObjects"
    }
  }), _vm._v(" "), _c('modal-inactive', {
    model: {
      value: (_vm.inactiveObjects),
      callback: function($$v) {
        _vm.inactiveObjects = $$v
      },
      expression: "inactiveObjects"
    }
  }), _vm._v(" "), _c('modal-separate-invoice', {
    model: {
      value: (_vm.separateInvoice),
      callback: function($$v) {
        _vm.separateInvoice = $$v
      },
      expression: "separateInvoice"
    }
  })], 1) : _vm._e()]), _vm._v(" "), (_vm.testEnvironment()) ? _c('button', {
    staticClass: "ls-btn",
    on: {
      "click": function($event) {
        _vm.createNextInvoice()
      }
    }
  }, [_vm._v("Gerar próxima fatura")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4d35e11d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/contracts/Show.vue
// module id = 772
// module chunks = 1